import React, {Suspense} from "react";
import {Redirect, Route} from "react-router-dom";
import Loader from "../components/CommonForBoth/Loader";
import {useSelector} from "react-redux";
import {isLegacySubdomain} from "../helpers/Util";

const AppRoute = ({
    component: Component,
    layout: Layout,
    isAuthProtected,
    ...rest
}) => {
    const org = useSelector((state) => state?.Variables?.org);

    return (
        <Route
            {...rest}
            render={(props) => {
                const authUser = JSON.parse(localStorage.getItem("authUser"));
                const originalOrg = localStorage.getItem("originalOrg");
                const host = window.location.hostname;
                const origin = window.location.origin;

                if (!isLegacySubdomain({host}) && authUser?.uiHost && !originalOrg) {
                    const expectedHost = org ? `${origin}/${org}` : origin;

                    if (authUser.uiHost !== expectedHost) {
                        localStorage.removeItem("authUser");
                        localStorage.removeItem("org");
                        window.location.replace(`${authUser.uiHost}/login?error=wrong-url`);
                        return null;
                    }
                }

                const expired = !authUser || Date.now() > authUser.expires;

                if (isAuthProtected && expired) {
                    return (
                        <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
                    );
                }

                return (
                    <Layout updateRoutes={rest.updateRoutes}>
                        <Suspense fallback={<Loader show message="Loading" />}>
                            <Component {...props} />
                        </Suspense>
                    </Layout>
                );
            }}
        />
    );
};

export default AppRoute;
